module.exports = __webpack_public_path__ + "static/img/logistics-h5-5.a78e740.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/logistics-h5-5.png
// module id = TKg+
// module chunks = 34